import { useCallback, useEffect, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import { severityNotificationsDict } from '../../../constants/variables';
import styles from './Notification.module.css';
import { connect } from 'react-redux';
import { onCloseNotification } from '../../../ac/onCloseNotification';
import Grow from '@material-ui/core/Grow';

const animationTimeout = 250;
const NotificationComponent = ({
    timeStamp,
    type,
    children,
    onCloseNotification,
}) => {
    const [ show, setShow ] = useState(true);
    const onClose = useCallback(() => {
        setShow(false);
        setTimeout(() => onCloseNotification(timeStamp), animationTimeout); // required for animation delay
    }, [ timeStamp, onCloseNotification ]);
    useEffect(() => {
        const timeout = setTimeout(onClose, 7000);
        return () => clearTimeout(timeout);
    }, [ onClose ]);
    return (
        <Grow
            in={show}
            timeout={animationTimeout}
        >
            <Alert
                elevation={6}
                variant='filled'
                severity={severityNotificationsDict[type]}
                onClose={onClose}
                className={styles.notification}
            >
                {children}
            </Alert>
        </Grow>
    );
};

export const Notification = connect(null, { onCloseNotification })(NotificationComponent);
